import { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function About() {
  useEffect(() => {
    document.title = 'About Us';
  }, []);

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <header className="border-b border-background-200 bg-background-50">
        <div className="mx-auto flex h-16 w-full max-w-5xl items-center justify-between px-4 md:px-6">
          <Link
            to="/"
            className="flex items-center gap-2 text-base font-semibold text-foreground-950"
          >
            <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-pages-line" />
            </span>
            <span className="font-heading">Site</span>
          </Link>
          <nav className="flex items-center gap-1 text-sm">
            <Link
              to="/"
              className="cursor-pointer rounded-md px-3 py-2 text-foreground-600 transition-colors hover:bg-background-100 hover:text-foreground-950"
            >
              Home
            </Link>
            <Link
              to="/about"
              className="cursor-pointer rounded-md bg-background-100 px-3 py-2 font-medium text-foreground-950"
            >
              About
            </Link>
          </nav>
        </div>
      </header>

      <main className="flex-1">
        <section className="mx-auto w-full max-w-5xl px-4 py-16 md:px-6 md:py-24">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-900">
            <i className="ri-information-line" />
            About
          </span>
          <h1 className="mt-5 font-heading text-3xl font-semibold text-foreground-950 md:text-5xl">
            About Us
          </h1>
          <p className="mt-5 max-w-2xl text-base leading-relaxed text-foreground-600 md:text-lg">
            This is a simple page. Replace this placeholder text with a short introduction
            about who you are, what you do, and what makes your team worth getting to know.
          </p>

          <div className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-3">
            <div className="rounded-lg border border-background-200 bg-background-50 p-6">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                <i className="ri-flag-line" />
              </span>
              <h2 className="mt-4 font-heading text-base font-semibold text-foreground-950">
                Our Mission
              </h2>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                A short line describing the purpose behind everything you do.
              </p>
            </div>
            <div className="rounded-lg border border-background-200 bg-background-50 p-6">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-100 text-accent-900">
                <i className="ri-team-line" />
              </span>
              <h2 className="mt-4 font-heading text-base font-semibold text-foreground-950">
                Our Team
              </h2>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                A short line introducing the people behind your work.
              </p>
            </div>
            <div className="rounded-lg border border-background-200 bg-background-50 p-6">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-secondary-100 text-secondary-900">
                <i className="ri-map-pin-line" />
              </span>
              <h2 className="mt-4 font-heading text-base font-semibold text-foreground-950">
                Where We Are
              </h2>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                A short line about your location or the area you serve.
              </p>
            </div>
          </div>
        </section>
      </main>

      <footer className="border-t border-background-200 bg-background-100">
        <div className="mx-auto flex w-full max-w-5xl flex-col items-center justify-between gap-3 px-4 py-8 text-sm text-foreground-500 sm:flex-row md:px-6">
          <p>&copy; 2026 Site. All rights reserved.</p>
          <Link to="/" className="cursor-pointer text-foreground-600 hover:text-foreground-950">
            Back to home
          </Link>
        </div>
      </footer>
    </div>
  );
}